﻿//import Highcharts from 'highcharts';

Highcharts.chart('trendsCigSmokeRate', {
	chart: {
		type: 'line',
		style: {
			fontFamily: 'Aeonik, Arial, sans-serif'
		}
	},
	legend: {
		itemStyle: {
			color: '#555559'
		},
		itemHoverStyle: {
			color: '#555559',
			cursor: 'default'
		}
	},
	title: {
		text: 'Cigarette smoking rates have fallen significantly for both youths and adults',
		style: {
			color: '#555559'
		}
	},
	subtitle: {
		text: 'American Lung Association analysis of CDC data: NHIS 1965-2018. YRBSS 1995-2017.'
	},
	xAxis: {
		type: 'datetime',
		dateTimeLabelFormats: {
			year: '%Y'
		},
		title: {
			text: 'Year'
		}
	},
	yAxis: {
		title: {
			text: 'Percent Current Smokers'
		},
		labels: {
			formatter: function () {
				return this.value + "%";
			}
		},
		min: 0
	},
	tooltip: {
		enabled: true
	},
	plotOptions: {
		series: {
			enableMouseTracking: true
		},
		line: {
			dataLabels: {
				enabled: false,
				color: '#555559',
				property: 'percentage',
				format: '{y}%'
			}
		}
	},
	colors: ['#0064FF', '#87414C'],
	credits: {
		enabled: false
	},
	exporting: {
		enabled: true
	},
	series: [{
		name: "Adult",
		data: [
			{ x: Date.UTC(1965, 0, 1), y: 42.4, dataLabels: { enabled: true } },
			[Date.UTC(1966, 0, 1), 42.6],
			[Date.UTC(1970, 0, 1), 37.4],
			[Date.UTC(1974, 0, 1), 37.1],
			[Date.UTC(1978, 0, 1), 34.1],
			[Date.UTC(1979, 0, 1), 33.5],
			[Date.UTC(1980, 0, 1), 33.2],
			[Date.UTC(1983, 0, 1), 32.1],
			[Date.UTC(1985, 0, 1), 30.1],
			[Date.UTC(1987, 0, 1), 28.8],
			[Date.UTC(1988, 0, 1), 28.1],
			[Date.UTC(1990, 0, 1), 25.5],
			[Date.UTC(1991, 0, 1), 27.5],
			[Date.UTC(1993, 0, 1), 25.0],
			[Date.UTC(1994, 0, 1), 25.5],
			[Date.UTC(1995, 0, 1), 24.7],
			[Date.UTC(1997, 0, 1), 24.7],
			[Date.UTC(1998, 0, 1), 24.1],
			[Date.UTC(1999, 0, 1), 23.5],
			[Date.UTC(2000, 0, 1), 23.3],
			[Date.UTC(2001, 0, 1), 22.8],
			[Date.UTC(2002, 0, 1), 22.5],
			[Date.UTC(2003, 0, 1), 21.6],
			[Date.UTC(2004, 0, 1), 20.9],
			[Date.UTC(2005, 0, 1), 20.9],
			[Date.UTC(2006, 0, 1), 20.6],
			[Date.UTC(2007, 0, 1), 19.8],
			[Date.UTC(2008, 0, 1), 20.6],
			[Date.UTC(2009, 0, 1), 20.6],
			[Date.UTC(2010, 0, 1), 19.3],
			[Date.UTC(2011, 0, 1), 19.0],
			[Date.UTC(2012, 0, 1), 18.1],
			[Date.UTC(2013, 0, 1), 17.8],
			[Date.UTC(2014, 0, 1), 16.8],
			[Date.UTC(2015, 0, 1), 15.1],
			[Date.UTC(2016, 0, 1), 15.1],
			[Date.UTC(2017, 0, 1), 14.0],
			{ x: Date.UTC(2018, 0, 1), y: 13.7, dataLabels: { enabled: true } }
		]
	}, {
		name: "Youth",
		data: [
			[Date.UTC(1991, 0, 1), 27.5],
			[Date.UTC(1993, 0, 1), 30.5],
			[Date.UTC(1995, 0, 1), 34.8],
			{ x: Date.UTC(1997, 0, 1), y: 36.4, dataLabels: { enabled: true } },
			[Date.UTC(1999, 0, 1), 34.8],
			[Date.UTC(2001, 0, 1), 28.5],
			[Date.UTC(2003, 0, 1), 21.9],
			[Date.UTC(2005, 0, 1), 23.0],
			[Date.UTC(2007, 0, 1), 20.0],
			[Date.UTC(2009, 0, 1), 19.5],
			[Date.UTC(2011, 0, 1), 18.1],
			[Date.UTC(2013, 0, 1), 15.7],
			[Date.UTC(2015, 0, 1), 15.7],
			{ x: Date.UTC(2017, 0, 1), y: 8.8, dataLabels: { enabled: true } }
		]
	}]
});

Highcharts.chart('trendsWhoSmokeHaveQuit', {
	chart: {
		zoomType: 'xy',
		style: {
			fontFamily: 'Aeonik, Arial, sans-serif'
		}
	},
	legend: {
		itemStyle: {
			color: '#555559'
		},
		itemHoverStyle: {
			color: '#555559',
			cursor: 'default'
		}
	},
	title: {
		text: 'There have been more former than current cigarette smokers since 2002 and more than half of ever cigarette smokers have quit',
		style: {
			color: '#555559'
		}
	},
	subtitle: {
		text: 'American Lung Association analysis of CDC data: NHIS 1965-2018.'
	},
	xAxis: [{
		title: {
			text: 'Year'
		},
		type: 'datetime',
		dateTimeLabelFormats: {
			year: '%Y'
		}
	}],
	yAxis: [{ // Primary yAxis
		title: {
			text: 'Percent'
		}
	},
	{ // Secondary yAxis
		title: {
			text: 'Millions'
		},
		opposite: true
	}],
	plotOptions: {
		series: {
			enableMouseTracking: true
		}
	},
	colors: ['#0064FF', '#87414C', '#EB8CED'],
	credits: {
		enabled: false
	},
	tooltip: {
		enabled: true
	},
	exporting: {
		enabled: true
	},
	series: [{
		name: 'Ever Smokers',
		type: 'line',
		dataLabels: {
			enabled: false,
			color: '#555559',
			align: 'left',
			format: '{point.y:,.1f}% of ever smokers have quit'
		},
		data: [
			[Date.UTC(1965, 0, 1), 24.2],
			[Date.UTC(1966, 0, 1), 24.2],
			[Date.UTC(1970, 0, 1), 33.1],
			[Date.UTC(1974, 0, 1), 34.5],
			[Date.UTC(1978, 0, 1), 37.9],
			[Date.UTC(1979, 0, 1), 38.9],
			[Date.UTC(1980, 0, 1), 39.0],
			[Date.UTC(1983, 0, 1), 40.4],
			[Date.UTC(1985, 0, 1), 44.6],
			[Date.UTC(1987, 0, 1), 44.2],
			[Date.UTC(1988, 0, 1), 45.8],
			[Date.UTC(1990, 0, 1), 49.1],
			[Date.UTC(1991, 0, 1), 48.4],
			[Date.UTC(1997, 0, 1), 48.0],
			[Date.UTC(1998, 0, 1), 48.7],
			[Date.UTC(1999, 0, 1), 49.5],
			[Date.UTC(2000, 0, 1), 48.8],
			[Date.UTC(2001, 0, 1), 49.2],
			[Date.UTC(2002, 0, 1), 50.1],
			[Date.UTC(2003, 0, 1), 50.3],
			[Date.UTC(2004, 0, 1), 50.6],
			[Date.UTC(2005, 0, 1), 50.8],
			[Date.UTC(2006, 0, 1), 50.2],
			[Date.UTC(2007, 0, 1), 52.1],
			[Date.UTC(2008, 0, 1), 51.1],
			[Date.UTC(2009, 0, 1), 51.7],
			[Date.UTC(2010, 0, 1), 52.9],
			[Date.UTC(2011, 0, 1), 53.5],
			[Date.UTC(2012, 0, 1), 55.1],
			[Date.UTC(2013, 0, 1), 55.2],
			[Date.UTC(2014, 0, 1), 56.6],
			[Date.UTC(2015, 0, 1), 59.1],
			[Date.UTC(2016, 0, 1), 59.1],
			[Date.UTC(2017, 0, 1), 61.7],
			{ x: Date.UTC(2018, 0, 1), y: 61.7, dataLabels: { enabled: true } }
		]
	}, {
		name: 'Current Smokers',
		type: 'line',
		yAxis: 1,
		dataLabels: {
			enabled: false,
			color: '#555559',
			align: 'left',
			format: '{point.y:,.1f} million current smokers'
		},
		data: [
			[Date.UTC(1997, 0, 1), 47.955412],
			[Date.UTC(1998, 0, 1), 47.190337],
			[Date.UTC(1999, 0, 1), 46.515266],
			[Date.UTC(2000, 0, 1), 46.522354],
			[Date.UTC(2001, 0, 1), 46.154963],
			[Date.UTC(2002, 0, 1), 45.821419],
			[Date.UTC(2003, 0, 1), 45.400103],
			[Date.UTC(2004, 0, 1), 44.457729],
			[Date.UTC(2005, 0, 1), 45.131473],
			[Date.UTC(2006, 0, 1), 45.296422],
			[Date.UTC(2007, 0, 1), 43.405925],
			[Date.UTC(2008, 0, 1), 45.954467],
			[Date.UTC(2009, 0, 1), 46.640676],
			[Date.UTC(2010, 0, 1), 44.113885],
			[Date.UTC(2011, 0, 1), 43.820699],
			[Date.UTC(2012, 0, 1), 42.098139],
			[Date.UTC(2013, 0, 1), 42.136507],
			[Date.UTC(2014, 0, 1), 39.961813],
			[Date.UTC(2015, 0, 1), 36.495093],
			[Date.UTC(2016, 0, 1), 37.778440],
			[Date.UTC(2017, 0, 1), 34.284673],
			{ x: Date.UTC(2018, 0, 1), y: 34.154200, dataLabels: { enabled: true } }
		]
	}, {
		name: 'Former Smokers',
		type: 'line',
		yAxis: 1,
		dataLabels: {
			enabled: false,
			color: '#555559',
			align: 'left',
			format: '{point.y:,.1f} million former smokers'
		},
		data: [
			[Date.UTC(1997, 0, 1), 44.272966],
			[Date.UTC(1998, 0, 1), 44.828632],
			[Date.UTC(1999, 0, 1), 45.669888],
			[Date.UTC(2000, 0, 1), 44.322498],
			[Date.UTC(2001, 0, 1), 44.776420],
			[Date.UTC(2002, 0, 1), 46.019398],
			[Date.UTC(2003, 0, 1), 45.939371],
			[Date.UTC(2004, 0, 1), 45.616841],
			[Date.UTC(2005, 0, 1), 46.522038],
			[Date.UTC(2006, 0, 1), 45.716659],
			[Date.UTC(2007, 0, 1), 47.291422],
			[Date.UTC(2008, 0, 1), 48.072247],
			[Date.UTC(2009, 0, 1), 49.878232],
			[Date.UTC(2010, 0, 1), 49.472964],
			[Date.UTC(2011, 0, 1), 50.415924],
			[Date.UTC(2012, 0, 1), 51.621850],
			[Date.UTC(2013, 0, 1), 51.934785],
			[Date.UTC(2014, 0, 1), 52.211873],
			[Date.UTC(2015, 0, 1), 52.828443],
			[Date.UTC(2016, 0, 1), 54.342556],
			[Date.UTC(2017, 0, 1), 55.208554],
			{ x: Date.UTC(2018, 0, 1), y: 54.987313, dataLabels: { enabled: true } }
		]
	}]
});

Highcharts.chart('trendsAvgCigPerDay', {
	chart: {
		type: 'area',
		style: {
			fontFamily: 'Aeonik, Arial, sans-serif'
		}
	},
	legend: {
		itemStyle: {
			color: '#555559'
		},
		itemHoverStyle: {
			color: '#555559',
			cursor: 'default'
		}
	},
	title: {
		text: 'The average number of cigarettes smoked per day continues to decrease among current smokers',
		style: {
			color: '#555559'
		}
	},
	subtitle: {
		text: 'American Lung Association analysis of CDC data: NHIS. 1974-2018.'
	},
	xAxis: {
		title: {
			text: 'Year'
		},
		type: 'datetime',
		dateTimeLabelFormats: {
			year: '%Y'
		}
	},
	yAxis: {
		title: {
			text: 'Percent'
		},
		min: 0
	},

	plotOptions: {
		series: {
			enableMouseTracking: true,
			fillOpacity: 1
		},
		area: {
			stacking: 'percent',
			lineColor: '#ffffff',
			lineWidth: 1,
			marker: {
				lineWidth: 1,
				lineColor: '#ffffff',
				enabled: false
			}
		},
	},
	colors: ['#0064FF', '#87414C', '#EB8CED'],
	credits: {
		enabled: false
	},
	tooltip: {
		enabled: true
	},
	exporting: {
		enabled: true
	},
	series: [{
		name: '> 24 cigarettes per day',
		dataLabels: {
			enabled: true,
			useHTML: true,
			color: '#ffffff',
			y: 40,
			formatter: function () {
				if (this.point.index === 6) {
					return '<b>' + this.series.name + '</b>';
				}
			}
		},
		data: [
			[Date.UTC(1974, 0, 1), 25.3],
			[Date.UTC(1975, 0, 1), 25.9],
			[Date.UTC(1976, 0, 1), 26.5],
			[Date.UTC(1977, 0, 1), 27.1],
			[Date.UTC(1978, 0, 1), 27.6],
			[Date.UTC(1979, 0, 1), 28.2],
			[Date.UTC(1980, 0, 1), 28.8],
			[Date.UTC(1981, 0, 1), 28.4],
			[Date.UTC(1982, 0, 1), 27.9],
			[Date.UTC(1983, 0, 1), 27.5],
			[Date.UTC(1984, 0, 1), 27.0],
			[Date.UTC(1985, 0, 1), 26.6],
			[Date.UTC(1986, 0, 1), 25.9],
			[Date.UTC(1987, 0, 1), 25.1],
			[Date.UTC(1988, 0, 1), 24.4],
			[Date.UTC(1989, 0, 1), 23.6],
			[Date.UTC(1990, 0, 1), 22.9],
			[Date.UTC(1991, 0, 1), 22.3],
			[Date.UTC(1992, 0, 1), 21.8],
			[Date.UTC(1993, 0, 1), 21.2],
			[Date.UTC(1994, 0, 1), 20.7],
			[Date.UTC(1995, 0, 1), 20.1],
			[Date.UTC(1996, 0, 1), 19.1],
			[Date.UTC(1997, 0, 1), 18.0],
			[Date.UTC(1998, 0, 1), 17.7],
			[Date.UTC(1999, 0, 1), 15.7],
			[Date.UTC(2000, 0, 1), 15.4],
			[Date.UTC(2001, 0, 1), 14.8],
			[Date.UTC(2002, 0, 1), 14.4],
			[Date.UTC(2003, 0, 1), 12.9],
			[Date.UTC(2004, 0, 1), 12.3],
			[Date.UTC(2005, 0, 1), 11.7],
			[Date.UTC(2006, 0, 1), 12.1],
			[Date.UTC(2007, 0, 1), 10.9],
			[Date.UTC(2008, 0, 1), 10.1],
			[Date.UTC(2009, 0, 1), 9.1],
			[Date.UTC(2010, 0, 1), 7.4],
			[Date.UTC(2011, 0, 1), 8.6],
			[Date.UTC(2012, 0, 1), 6.5],
			[Date.UTC(2013, 0, 1), 6.3],
			[Date.UTC(2014, 0, 1), 6.3],
			[Date.UTC(2015, 0, 1), 6.4],
			[Date.UTC(2016, 0, 1), 6.7],
			[Date.UTC(2017, 0, 1), 5.4],
			[Date.UTC(2018, 0, 1), 6.1]
		]
	}, {
		name: '15-24 cigarettes per day',
		dataLabels: {
			enabled: true,
			useHTML: true,
			color: '#ffffff',
			y: 60,
			formatter: function () {
				if (this.point.index === 6) {
					return '<b>' + this.series.name + '</b>';
				}
			}
		},
		data: [
			[Date.UTC(1974, 0, 1), 43.2],
			[Date.UTC(1975, 0, 1), 43.0],
			[Date.UTC(1976, 0, 1), 42.8],
			[Date.UTC(1977, 0, 1), 42.7],
			[Date.UTC(1978, 0, 1), 42.5],
			[Date.UTC(1979, 0, 1), 42.3],
			[Date.UTC(1980, 0, 1), 42.1],
			[Date.UTC(1981, 0, 1), 42.0],
			[Date.UTC(1982, 0, 1), 42.0],
			[Date.UTC(1983, 0, 1), 41.9],
			[Date.UTC(1984, 0, 1), 41.9],
			[Date.UTC(1985, 0, 1), 41.8],
			[Date.UTC(1986, 0, 1), 42.0],
			[Date.UTC(1987, 0, 1), 42.1],
			[Date.UTC(1988, 0, 1), 42.3],
			[Date.UTC(1989, 0, 1), 42.4],
			[Date.UTC(1990, 0, 1), 42.6],
			[Date.UTC(1991, 0, 1), 41.9],
			[Date.UTC(1992, 0, 1), 41.2],
			[Date.UTC(1993, 0, 1), 40.4],
			[Date.UTC(1994, 0, 1), 39.7],
			[Date.UTC(1995, 0, 1), 39.0],
			[Date.UTC(1996, 0, 1), 39.4],
			[Date.UTC(1997, 0, 1), 39.7],
			[Date.UTC(1998, 0, 1), 39.9],
			[Date.UTC(1999, 0, 1), 39.1],
			[Date.UTC(2000, 0, 1), 38.8],
			[Date.UTC(2001, 0, 1), 38.5],
			[Date.UTC(2002, 0, 1), 37.0],
			[Date.UTC(2003, 0, 1), 36.1],
			[Date.UTC(2004, 0, 1), 37.2],
			[Date.UTC(2005, 0, 1), 36.6],
			[Date.UTC(2006, 0, 1), 35.3],
			[Date.UTC(2007, 0, 1), 34.1],
			[Date.UTC(2008, 0, 1), 34.9],
			[Date.UTC(2009, 0, 1), 32.9],
			[Date.UTC(2010, 0, 1), 33.7],
			[Date.UTC(2011, 0, 1), 31.8],
			[Date.UTC(2012, 0, 1), 33.2],
			[Date.UTC(2013, 0, 1), 30.5],
			[Date.UTC(2014, 0, 1), 28.2],
			[Date.UTC(2015, 0, 1), 29.7],
			[Date.UTC(2016, 0, 1), 28.6],
			[Date.UTC(2017, 0, 1), 29.3],
			[Date.UTC(2018, 0, 1), 28.1]
		]
	}, {
		name: '< 15 cigarettes per day',
		dataLabels: {
			enabled: true,
			useHTML: true,
			color: '#ffffff',
			y: 40,
			formatter: function () {
				if (this.point.index === 6) {
					return '<b>' + this.series.name + '</b>';
				}
			}
		},
		data: [
			[Date.UTC(1974, 0, 1), 31.6],
			[Date.UTC(1975, 0, 1), 31.2],
			[Date.UTC(1976, 0, 1), 30.8],
			[Date.UTC(1977, 0, 1), 30.4],
			[Date.UTC(1978, 0, 1), 29.9],
			[Date.UTC(1979, 0, 1), 29.5],
			[Date.UTC(1980, 0, 1), 29.1],
			[Date.UTC(1981, 0, 1), 29.6],
			[Date.UTC(1982, 0, 1), 30.1],
			[Date.UTC(1983, 0, 1), 30.6],
			[Date.UTC(1984, 0, 1), 31.1],
			[Date.UTC(1985, 0, 1), 31.6],
			[Date.UTC(1986, 0, 1), 32.2],
			[Date.UTC(1987, 0, 1), 32.8],
			[Date.UTC(1988, 0, 1), 33.3],
			[Date.UTC(1989, 0, 1), 33.9],
			[Date.UTC(1990, 0, 1), 34.5],
			[Date.UTC(1991, 0, 1), 35.8],
			[Date.UTC(1992, 0, 1), 37.1],
			[Date.UTC(1993, 0, 1), 38.3],
			[Date.UTC(1994, 0, 1), 39.6],
			[Date.UTC(1995, 0, 1), 40.9],
			[Date.UTC(1996, 0, 1), 41.6],
			[Date.UTC(1997, 0, 1), 42.3],
			[Date.UTC(1998, 0, 1), 42.4],
			[Date.UTC(1999, 0, 1), 45.2],
			[Date.UTC(2000, 0, 1), 45.8],
			[Date.UTC(2001, 0, 1), 46.7],
			[Date.UTC(2002, 0, 1), 48.6],
			[Date.UTC(2003, 0, 1), 51.1],
			[Date.UTC(2004, 0, 1), 50.4],
			[Date.UTC(2005, 0, 1), 51.7],
			[Date.UTC(2006, 0, 1), 52.6],
			[Date.UTC(2007, 0, 1), 55.0],
			[Date.UTC(2008, 0, 1), 55.1],
			[Date.UTC(2009, 0, 1), 58.0],
			[Date.UTC(2010, 0, 1), 58.9],
			[Date.UTC(2011, 0, 1), 59.5],
			[Date.UTC(2012, 0, 1), 60.3],
			[Date.UTC(2013, 0, 1), 63.2],
			[Date.UTC(2014, 0, 1), 65.5],
			[Date.UTC(2015, 0, 1), 63.9],
			[Date.UTC(2016, 0, 1), 64.6],
			[Date.UTC(2017, 0, 1), 65.3],
			[Date.UTC(2018, 0, 1), 65.8]
		]
	}]
});

Highcharts.chart('youthECigaretteType', {
	chart: {
		type: 'bar',
		style: {
			fontFamily: 'Aeonik, Arial, sans-serif'
		}
	},
	title: {
		text: 'Youth E-Cigarette Type'
	},
	subtitle: {
		text: 'American Lung Association Analysis of CDC data: NYTS, 2019'
	},
	xAxis: {
		categories: ['Type of e-cigarette used most often']
	},
	yAxis: {
		min: 0,
		max: 100,
		labels: {
			format: '{value}%'
		},
		title: {
			text: undefined
		}
	},
	credits: {
		enabled: false
	},
	colors: ['#0064FF', '#87414C', '#EB8CED', '#D1E33B', '#002158'],
	legend: {
		reversed: true,
		enabled: true
	},
	plotOptions: {
		series: {
			stacking: 'normal',
			dataLabels: {
				align: 'center',
				enabled: true,
				format: '{point.y}%',
				style: {
					textAlign: 'center'
				},
				position: 'center'
			}
		}
	},
	series: [{
		name: 'Disposable',
		data: [{
			y: 2.7
		}]
	}, {
		name: 'Do not know the type',
		data: [{
			y: 9.0
		}]
	}, {
		name: 'Mod system',
		data: [{
			y: 10.1
		}]
	}, {
		name: 'With a tank that you refill with liquids',
		data: [{
			y: 24.3
		}]
	}, {
		name: 'Uses pre-filled pods or cartridges (e.g. JUUL)',
		data: [{
			y: 53.9
		}]
	}]
});

Highcharts.chart('youthECigaretteBrand', {
	chart: {
		type: 'bar',
		style: {
			fontFamily: 'Aeonik, Arial, sans-serif'
		}
	},
	title: {
		text: 'Youth E-Cigarette Brand'
	},
	subtitle: {
		text: 'American Lung Association Analysis of CDC data: NYTS, 2019'
	},
	xAxis: {
		categories: ['Brand of e-cigarette usually used']
	},
	yAxis: {
		min: 0,
		max: 100,
		labels: {
			format: '{value}%'
		},
		title: {
			text: undefined
		}
	},
	credits: {
		enabled: false
	},
	legend: {
		reversed: true,
		enabled: true
	},
	colors: ['#0064FF', '#87414C', '#EB8CED', '#D1E33B'],
	plotOptions: {
		series: {
			stacking: 'normal',
			dataLabels: {
				align: 'center',
				enabled: true,
				format: '{point.y}%',
				style: {
					textAlign: 'center'
				},
				position: 'center'
			}
		}
	},
	series: [{
		name: 'Blu, Vuse, NJOY, Logic, or MarkTen',
		data: [{
			y: 8.7
		}]
	}, {
		name: 'No usual brand',
		data: [{
			y: 14.6
		}]
	}, {
		name: 'Some other brand not listed here',
		data: [{
			y: 18.9
		}]
	}, {
		name: 'JUUL',
		data: [{
			y: 57.8
		}]
	}]
});
